import { render, staticRenderFns } from "./mark-as-flagged.vue?vue&type=template&id=896854aa&"
import script from "./mark-as-flagged.js?vue&type=script&lang=js&"
export * from "./mark-as-flagged.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports